import { Component, OnInit, Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';

import { FormField } from '../forms/form-field.model';

@Component({
  selector: 'app-extend-expiration-dialog',
  templateUrl: './extend-expiration-dialog.component.html',
  styleUrls: ['./extend-expiration-dialog.component.scss']
})
export class ExtendExpirationDialogComponent implements OnInit {

  expiration: moment.Moment;
  field: FormField;
  previousExpiration: moment.Moment;
  today: moment.Moment;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.today = moment();
    let expiration = moment(this.data.expiration, 'YYYY-MM-DD');
    if (!expiration.isValid()) { expiration = this.today };
    this.expiration = expiration;
    this.previousExpiration = expiration;

    let min = 0;
    let max = 45;

    this.field = new FormField();
    this.field.min = min;
    this.field.max = max;
  }

  onValueChange(event) {
    this.expiration = event.value != null ? moment(event.value) : null;
  }

  onClose() {
    let value = this.expiration
    if (value.isSame(this.today, 'day')) {
      // If the users set the date to today,
      // assume they want to immediately expire
      value = value.subtract(1, 'days')
    } else {
      value = this.expiration
    }
    return {expiration: value.format('YYYY-MM-DD')}
  }
}


// WEBPACK FOOTER //
// ./src/app/transfers/extend-expiration-dialog.component.ts